//3rd Party Components
import React, { Fragment } from 'react';
import moment from 'moment';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from 'react';

//Components
import CASASpinner from '../components/Portal/CASASpinner';
import ProfileTile from '../components/Portal/ProfileTile';
import Heading from '../components/CASA/Heading';
import Container from '../components/CASA/Container';

//Actions and Selectors
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getLicencesIndividual, FETCH_LICENCESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/LicencesIndividualActions';
import { getREOCsIndividual, FETCH_REOCSINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/REOCsIndividualActions';
import { getDronesIndividual, FETCH_DRONESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/DronesIndividualActions';
import { getDronesProfile, FETCH_DRONESPROFILE_SUCCESS } from '../PortalStore/Actions/DronesProfileActions';
import { getCertificatesProfile, FETCH_CERTIFICATESPROFILE_SUCCESS } from '../PortalStore/Actions/CertificatesProfileActions';
import { getSRARNsOrganisation, FETCH_SRARNSORGANISATION_SUCCESS } from '../PortalStore/Actions/SRARNsOrganisationActions';

import { getExpirySelector, getFeatureSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getUserDetailsSelector } from '../PortalStore/Selectors/UserDetailsSelectors';

export const ProfileSelectorPage = () => {
    let history = useHistory();
    let dispatch = useDispatch();

    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [pageLoadedError, setPageLoadedError] = useState(false);
    const [pageLoadedErrorMessage, setPageLoadedErrorMessage] = useState("");

    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let userdetails = useSelector(state => state.userdetails);
    let participants = useSelector(state => state.participants);
    let srarnsIndividual = useSelector(state => state.srarnsIndividual);
    let tagsIndividual = useSelector(state => state.tagsIndividual);
    let acceptedSRsIndividual = useSelector(state => state.acceptedSRsIndividual);
    let draftarnsIndividual = useSelector(state => state.draftArnsIndividual);
    let licencesIndividual = useSelector(state => state.licencesIndividual);
    let appsIndividual = useSelector(state => state.appsIndividual);
    let alertsIndividual = useSelector(state => state.alertsIndividual);
    let certificatesIndividual = useSelector(state => state.certificatesIndividual);
    let dronesIndividual = useSelector(state => state.dronesIndividual);
    let aircraftIndividual = useSelector(state => state.aircraftIndividual);
    let tooIndividual = useSelector(state => state.tooIndividual);
    let REOCsIndividual = useSelector(state => state.REOCsIndividual);
    let REPLsIndividual = useSelector(state => state.REPLsIndividual);
    let srsOrganisation = useSelector(state => state.srsOrganisation);
    let certificatesProfile = useSelector(state => state.certificatesProfile);
    let dronesProfile = useSelector(state => state.dronesProfile);

    let expiryLic = useSelector(state => getExpirySelector(state, "Portal - Licence expiry warning period"));
    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));
    let expirySavedApp = useSelector(state => getExpirySelector(state, "Portal - Saved Application expiry warning period"));
    let expiryCert = useSelector(state => getExpirySelector(state, "Portal - Certificate expiry warning period"));

    let fullname = useSelector(state => getUserDetailsSelector(state, "fullname"));
    let arn = useSelector(state => getUserDetailsSelector(state, "casa_arn"));

    let featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));

    let pageAlert = useSelector(state => state.pageAlert);

    if (!pageLoaded && pageAlert.level !== "") {
        dispatch(addPageAlert({ level: "", title: "", message: "" }));
    }

    useEffect(() => {
        const webappurl = B2CSettings.items.webappurlPortalApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const webappurlF = B2CSettings.items.webappurlFormsApi;
        const accessTokenF = B2CSettings.items.accesstokenForms;
        const droneTypes = featureRecDrone ? ['recreational', 'commercial'] : ['commercial'];

        setPageLoading(true);

        axios.all([
            dispatch(getLicencesIndividual(webappurl, accessToken)),
            //dispatch(getREOCsIndividual(webappurlF, accessTokenF)),
            dispatch(getDronesIndividual(webappurlF, accessToken, droneTypes)),
            dispatch(getDronesProfile(webappurl, accessToken, participants)),
            //dispatch(getCertificatesProfile(webappurl, accessToken, participants)),
            dispatch(getSRARNsOrganisation(webappurl, accessToken, participants))
        ])
            .then(axios.spread((licsres, dronesindres, dronesprofres, srsres) => {
                if (licsres.type === FETCH_LICENCESINDIVIDUAL_SUCCESS
                    //&& reocsres.type === FETCH_REOCSINDIVIDUAL_SUCCESS
                    && dronesindres.type === FETCH_DRONESINDIVIDUAL_SUCCESS
                    && dronesprofres.type === FETCH_DRONESPROFILE_SUCCESS
                    //&& certsres.type === FETCH_CERTIFICATESPROFILE_SUCCESS
                    && srsres.type === FETCH_SRARNSORGANISATION_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoadedError(true);
                    setPageLoadedErrorMessage("PS.1");
                    setPageLoading(false);
                    setPageLoaded(true);
                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: PS.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function (error) {
                setPageLoadedError(true);
                setPageLoadedErrorMessage("PS.2");
                setPageLoading(false);
                setPageLoaded(true);

                dispatch(addPageAlert({ level: "error", title: "System error PS.2" }));
            });

    }, []);

    const findByOrgId = (val, index, arr) => {
        return (val.orgid === this);
    }

    const orgtiles = () => {

        return (
            participants.items.participantsAll.map((p, index) => {
                let messagesOrg = [];

                // drone regos expiring for this individual's participants
                let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
                let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');

                let message = '';
                let msglevel = '';
                let dronesProf = dronesProfile.items.value;
                let profDronesCount = dronesProfile.items.value ? dronesProfile.items.value.length : 0;

                for (var i = 0; i < profDronesCount; i++) {
                    if (dronesProf[i]["account.accountid"] === p["account.accountid"]) {
                        if (moment(dronesProf[i]["casa_validuntil"]) < moment() && moment(dronesProf[i]["casa_validuntil"], "YYYY-MM-DD") > expiredRPA) {
                            // expired
                            message = 'Items expiring soon';
                            msglevel = 'warning';
                        }
                        if (moment(dronesProf[i]["casa_validuntil"]) > moment() && moment(dronesProf[i]["casa_validuntil"], "YYYY-MM-DD") < expiringRPA) {
                            // expiring
                            message = 'Items expiring soon';
                            msglevel = 'warning';
                        }
                        let msg = { "message": message, "level": msglevel };
                        if (messagesOrg.findIndex(el => el.msg.message === msg.message && el.msg.level === msg.level) === -1) {
                            messagesOrg.push({ 'msg': msg });
                        }
                    }
                }

                //let orgCerts = certificatesProfile.items.orgCerts;
                //let org = !orgCerts ? null : orgCerts.find(el => el["account.accountid"] === p["account.accountid"]);
                //let expiryCertDays = moment().add(expiryCert, 'days');
                //let today = moment().startOf('day');

                // check certificate expiring for this organisation
                //let activeto = moment(org["cert.casa_activeto"]); 
                //if (expiryCertDays > activeto && activeto >= today) {               
                //    let msg = { "message": "Items expiring soon", "level": "warning" };
                //    if (messagesOrg.findIndex(el => el.message === this.message && el.level === this.level) === -1) {
                //        messagesOrg.push({ 'msg': msg });
                //    }           
                //}

                //let orgArnsCount = srsOrganisation.items.valuearns ? srsOrganisation.items.valuearns.length : 0;
                //let orgReocsCount = srsOrganisation.items.valuereocs ? srsOrganisation.items.valuereocs.length : 0;
                //let orgReplsCount = srsOrganisation.items.valuerepls ? srsOrganisation.items.valuerepls.length : 0;

                //if (orgArnsCount + orgReocsCount + orgReplsCount > 0) {
                //    let msg = {
                //        "message": "In Progress",
                //        "level": "success"
                //    };

                //    if (messagesOrg.findIndex(el => el.message === this.message && el.level === this.level) === -1) {
                //        messagesOrg.push({ 'msg': msg });
                //    }
                //}




                //let dronesProfile = dronesProfile.items;
                //for (let i = 0; i < dronesProfile.length; i++) {
                //    if (dronesProfile[i]["accountid"] === p["account.accountid"]) {
                //        let activeto = moment(org["drone.casa_validuntil"]);
                //        if (expiryDrone > activeto && activeto >= today) {
                //            let msg = { "message": "Items expiring soon", "level": "warning" };
                //            if (messagesOrg.findIndex(el => el.message === this.message && el.level === this.level) === -1) {
                //                messagesOrg.push({ 'msg': msg });
                //            }
                //        }
                //    }
                //}

                let jparams = {
                    from: "org",
                    organisationId: p["account.accountid"]
                }

                let link = '/dashorg?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

                return (
                    <div className="col-lg-6 col-xs-12 col-md-12" key={p["account.casa_arn"]}>
                        <ProfileTile
                            key={index}
                            name={p["account.name"]}
                            arn={p["account.casa_arn"]}
                            link={link}
                            type="Organisation"
                            role={p["role.casa_name"]}
                            messages={messagesOrg}
                        />
                    </div>
                )
            })
        )
    }

    const indtile = () => {

        let messagesInd = [];
        let msg = null;

        // check drone regos expiring for this individual (refactor into utils?)

        let dronesInd = dronesIndividual.items.value;
        let indDronesCount = dronesIndividual.items.value ? dronesIndividual.items.value.length : 0;

        let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
        let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');

        let message = '';
        let msglevel = '';
        for (var i = 0; i < indDronesCount; i++) {
            if (moment(dronesInd[i]["casa_validuntil"], "YYYY-MM-DD") < moment() && moment(dronesInd[i]["casa_validuntil"], "YYYY-MM-DD") > expiredRPA) {
                // expired
                message = 'Items expiring soon';
                msglevel = 'warning';
                let msg = { "message": message, "level": msglevel };
                if (messagesInd.findIndex(el => el.msg.message === msg.message && el.msg.level === msg.level) === -1) {
                    messagesInd.push({ 'msg': msg });
                }
            }
            if (moment(dronesInd[i]["casa_validuntil"], "YYYY-MM-DD") > moment() && moment(dronesInd[i]["casa_validuntil"], "YYYY-MM-DD") < expiringRPA) {
                // expiring
                message = 'Items expiring soon';
                msglevel = 'warning';
                let msg = { "message": message, "level": msglevel };
                if (messagesInd.findIndex(el => el.msg.message === msg.message && el.msg.level === msg.level) === -1) {
                    messagesInd.push({ 'msg': msg });
                }
            }
        }

        //let tomorrow = moment().startOf('day').add(1, 'days');

        //let licsInd = licencesIndividual.items.value;
        //let certsProf = certificatesProfile.items.indCertParticipants; //certsInd?

        ////items in progress - active srs for this ind
        //let indArnsCount = srarnsIndividual.items.value ? srarnsIndividual.items.value.length : 0;
        ////sessionStorage.setItem("casa.indarnsCount", "{{indarns_query.results.entities.size}}"); //used - when removing drafts? put in redux

        //let indLicsCount = licencesIndividual.items.value ? licencesIndividual.items.value.length : 0;

        //debugger;
        ////need in progress (SRs) here //need drones in prog 
        //let indReocsCount = REOCsIndividual.items.value ? REOCsIndividual.items.value.length : 0;
        //let indDronesCountIP = 0; //need drones in prog //dronesIndividual.items.value ? dronesIndividual.items.value.length : 0;
        //if (indArnsCount + indReocsCount + indDronesCountIP > 0) { //?drones
        //    msg = { "message": "In Progress", "level": "success" };
        //    if (messagesInd.findIndex(el => el.message === this.message && el.level === this.level) === -1) {
        //        messagesInd.push({ 'msg': msg });
        //    }
        //}

        //let certsProfCount = certsProf ? certsProf.length : 0;

        //let expiryCertDays = moment().add(expiryCert, 'days');

        //if (certsProfCount > 0) {
        //    let profCertificate = certsProf[0];

        //    // check certificate expiring for this individual
        //    let activeto = moment(profCertificate["cert.casa_activeto"]);
        //    let today = moment().startOf('day');

        //    if (expiryCertDays > activeto && activeto >= today) {
        //        let msg = { "message": "Items expiring soon", "level": "warning" };
        //        if (messagesInd.findIndex(el => el.message === this.message && el.level === this.level) === -1) {
        //            messagesInd.push({ 'msg': msg });
        //        }
        //    }
        //}
        /*
          var indLicences = [];
        
            // check licences expiring for this individual
            var warning = false;
            var daysLic = sessionStorage.getItem("casa.g_LICENCE_EXPIRY");
            var expiryLic = moment().startOf('day').add(daysLic, 'days').subtract(1, 'days');
            var tomorrow =  moment().add(1, 'days');
            var today =  moment().startOf('day');
        
            {% for l in indLicences -%}
        
                {% capture validUntil %}{{l["casa_validuntil"]}}{% endcapture %}
        
                {% assign cat = "" %}
                {% if l["lictype.casa_name"] == "RePL" %}
                    {% assign cat = "repl" %}
                {% elseif l["lictype.casa_name"] contains 'Recreational' %}
                    {% assign cat = "rec" %}
                {% elseif l["lictype.casa_name"] contains "Excluded" %}
                    {% assign cat = "comm" %}
                {% endif %}
        
        
                {% if validUntil == "" %}
        
                indLicences.push({
                    'casa_name': '{{l["casa_name"]}}',
                    'casa_validuntil': '',
                    'expiry_warning': '',
                    'type': '{{l["lictype.casa_name"]}}',
                    'category': '{{l["cattype.casa_name"]}}',
                    'id': '{{l["casa_licenceid"]}}',
                    'license_type': "{{cat}}",
                    'casa_eapstatus': "{{l['casa_eapstatus']}}",
                    'comp_name': '{{l["comp.casa_name"]}}'
                });
        
                {% else %}
        
                var activeto = moment('{{l["casa_validuntil"]}}');
        
                warning = false;
        
                if (expiryLic > activeto && activeto >= today) {
                    warning = true;
                }
        
                indLicences.push({
                    'casa_name': '{{l["casa_name"]}}',
                    'casa_validuntil': '{{l["casa_validuntil"]}}',
                    'expiry_warning': warning,
                    'type': '{{l["lictype.casa_name"]}}',
                    'category': '{{l["cattype.casa_name"]}}',
                    'id': '{{l["casa_licenceid"]}}',
                    'license_type': "{{cat}}",
                    'casa_eapstatus': "{{l['casa_eapstatus']}}",
                    'comp_name': '{{l["comp.casa_name"]}}'
                });
        
                {% endif %}
        
            {% endfor %}
        
        var recordtokeep;
        for (var i = 0; i < indLicences.length; i++) {
            if(indLicences[i].casa_eapstatus == "Active" && moment(indLicences[i].casa_validuntil) < tomorrow) {
                continue;
            }
            recordtokeep = indLicences[i];
            break;
        }
        
        indLicences = [];
        if(recordtokeep  != undefined) indLicences.push(recordtokeep);
         */
        // check licences expiring for this individual
        //let expiryLicDays = moment().startOf('day').add(expiryLic, 'days').subtract(1, 'days');

        //for (let i = 0; i < indLicsCount; i++) {
        //    let activeto = moment(licsInd[i]["casa_validuntil"]);
        //    if (expiryLicDays > activeto && activeto > tomorrow) {
        //        let msg = { "message": "Items expiring soon", "level": "warning" };
        //        if (messagesInd.findIndex(el => el.message === msg.message && el.level === msg.level) === -1) {
        //            messagesInd.push({ 'msg': msg });
        //        }
        //    }
        //}       
        let jparams = {
            from: "ind",
            organisationId: ""
        }

        let link = '/dashind?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)));

        return (
            <div className="col-lg-6 col-xs-12 col-md-12" key={arn}>
                <ProfileTile
                    name={fullname}
                    arn={arn}
                    link={link}
                    type="Individual"
                    role=""
                    messages={messagesInd}
                />
            </div>
        )
    }

    const profiles = () => {
        return (
            <Fragment>
                {indtile()}

                {orgtiles()}
            </Fragment>
        )
    }

    const showTiles = () => {
        if (!pageLoadedError) {
            return (
                <div className="row">
                    <div className="col-xs-12 col-md-12 col-lg-12">
                        <p>Which profile do you want to use to access myCASA?</p>
                    </div>

                    <div className="casa-profiles" >
                        {profiles()}
                    </div>
                </div>
            )
        }
    }

    if (pageLoading) {
        return (
            <CASASpinner message="Working. Please wait...." />
        );
    }
    else {
        if (!pageLoaded) {
            return null;
        }

        return (
            <Container show={true}>
                <MetaTags>
                    <title>Profile Selector</title>
                </MetaTags>

                <Heading
                    id="profileheading"
                    text="Please select a profile"
                    subtext=""
                    showcrumbs={false}
                    showback={false} >

                </Heading>

                {showTiles()}

            </Container>
        );
    }

}

